export default __webpack_public_path__ + "static/media/8.66affce9.png";